import { render, staticRenderFns } from "./PictureIntroduction.vue?vue&type=template&id=2351a250&scoped=true&"
import script from "./PictureIntroduction.vue?vue&type=script&lang=js&"
export * from "./PictureIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./PictureIntroduction.vue?vue&type=style&index=0&id=2351a250&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351a250",
  null
  
)

export default component.exports